import { createModel } from '@rematch/core';
import { v4 as uuid } from 'uuid';
import { RecordModel, RecordIDModel } from '@equifinance/shared';
import { RootModel } from '.';

const fields = [
  'referralId',
  'referralType',
  'note',
] as const;
export type ReferralReason = RecordIDModel<typeof fields[number]>;

const referralReasonsModel = createModel<RootModel>()({
  ...RecordModel<ReferralReason>(fields),
  effects: (dispatch) => ({
    async createReferralReason(referralReason: Partial<ReferralReason>) {
      const id = uuid();
      dispatch.referralReasons.CREATE(id, referralReason);

      return id;
    },
  }),
});

export default referralReasonsModel;
